export enum PopupFlagPosition {
    NONE = 0,
    TOPLEFT,
    TOPRIGHT,
    BOTTOMLEFT,
    BOTTOMRIGHT,
    LEFT
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/PopupFlagPositions.ts